import { Box, DashboardModule } from '@domain-group/suit-theme'

import type { TaskListModel } from '@domain-group/realhub-backend-api-types'

import { useRelations } from '@hooks/useTaskList'

import User from './User'

interface ChecklistUserProps {
  taskList: TaskListModel,
}

const ChecklistUser = (props: ChecklistUserProps) => {
  const { taskList } = props
  const { user } = useRelations(taskList)

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Completed By">
      <Box
        flexDirection="column"
      >
        {/*
         // @ts-expect-error TS2741 */}
        <User taskList={taskList} user={user} />
      </Box>

    </DashboardModule>
  )
}

export default ChecklistUser
